<template>
    <div class="layout-container">
        <AppTopBar @menubutton-click="onMenuButtonClick" @change-password="changePasswordTopbarClick" />
        <!-- <div :class="['layout-mask', { 'layout-mask-active': sidebarActive }]" @click="onMaskClick"></div> -->
        <!-- <app-menu :active="sidebarActive" /> -->
        <app-menu :active="sidebarActive" :items="items" />
        <div :class="containerClass">
            <!-- <AppNews /> -->
            <div class="layout-content">
                <slot></slot>
                <!-- </div> -->
            </div>
            <AppFooter />
            <Toast />
            <Toast position="top-left" group="tl" />
            <Toast position="bottom-left" group="bl" />
            <Toast position="bottom-right" group="br" />
            <AppChangeDialog :visible="isDialogChangePass" @close-dialog="closeDialog" :closable="closable" />
            <!-- Add this line to call AppChangeDialog -->
        </div>
    </div>

    <ClientOnly>
        <ConfirmDialog group="headless" style="width: fit-content">
            <template #container="{ message, acceptCallback, rejectCallback }">
                <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
                    <div
                        class="rounded-full bg-primary text-primary-contrast inline-flex justify-center items-center h-24 w-24 -mt-20">
                        <i :class="`pi ${message.icon} text-5xl text-white`"></i>
                    </div>
                    <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
                    <p class="mb-0 text-lg">{{ message.message }}</p>
                    <div class="flex items-center gap-2 mt-6">
                        <Button name="ĐỒNG Ý" @click="acceptCallback"></Button>
                        <Button name="KHÔNG" outlined @click="rejectCallback"></Button>
                    </div>
                </div>
            </template>
        </ConfirmDialog>
    </ClientOnly>

</template>

<script setup>
import { blockBodyScroll, unblockBodyScroll } from '@primeuix/utils/dom';
const { status, data, getSession } = useAuth()

const sidebarActive = ref(false);
const route = useRoute();

const items = computed(() => {
    return status.value == 'authenticated' ? data.value.menuData : []
})
const closable = ref(false)
const isDialogChangePass = ref(false);
const isChangePassword = computed(() => {
    return status.value == 'authenticated' ? data.value.isChangePassword : false
})

watch(route, () => {
    if (!process.client || typeof window === 'undefined') {
        return;
    }

    sidebarActive.value = false;
    unblockBodyScroll('blocked-scroll');
    // Assuming you have a toast instance available
    // this.$toast.removeAllGroups();
});

const closeDialog = async () => {
    isDialogChangePass.value = false;
    await getSession();
};
const changePasswordTopbarClick = () => {
    closable.value = true;
    isDialogChangePass.value = true;
};
const onMenuButtonClick = () => {
    if (sidebarActive.value) {
        sidebarActive.value = false;
        unblockBodyScroll('blocked-scroll');
    } else {
        sidebarActive.value = true;
        blockBodyScroll('blocked-scroll');
    }
};

const onMaskClick = () => {
    sidebarActive.value = false;
    unblockBodyScroll('blocked-scroll');
};

const containerClass = computed(() => [
    'layout-wrapper',
    {
        'layout-news-active': false // Replace with your actual condition
    },
    {
        'inactive': sidebarActive.value
    }
]);

watch(isChangePassword, (newValue) => {
    closable.value = false;
    isDialogChangePass.value = newValue;
},
    { immediate: true }
);
</script>
